import { COLORS } from "@coeff/utils";
import { Radio as RadioAD } from "antd";
import styled from "styled-components";

const StyledRadio = styled(RadioAD)`
  .ant-radio-inner {
    border-width: 2px;
  }

  .ant-radio-checked {
    .ant-radio-inner {
      border-color: ${COLORS.coeblue4};

      &:after {
        top: 2px;
        left: 2px;
        background-color: ${COLORS.coeblue4};
      }
    }

    &:after {
      animation-duration: 0s !important;
    }
  }

  .ant-radio-button-wrapper-checked {
    background: ${COLORS.coeblue4};
    border-color: ${COLORS.coeblue4};
  }

  &.error {
    .ant-radio {
      .ant-radio-inner {
        border-color: ${COLORS.red};
      }
    }
  }
`;

export const RadioGroup = styled(StyledRadio.Group)<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ?? 3) * 8}px;
  font-size: 14px;

  .ant-radio-wrapper {
    line-height: 1.3 !important;
    max-width: 100%;
  }

  .ant-radio + span {
    display: inline-block;
    max-width: 100%;
  }
`;

export const Radio = StyledRadio;
